import { LoadingSkeleton, Text } from '@joor/design-system'

import { GetManageImagesStyleDataPayload as Style } from '__generated__/atlas-types'

import { formatNameWithCodeAndDash } from 'utils/formatters'
import { fromGlobalId } from 'utils/transformations/graphql'

import { StyleInfoIds } from 'features/Linesheets/Modals/ManageImagesModal/manageImagesModal.ids'
import useManageImagesStore from 'features/Linesheets/Modals/ManageImagesModal/store/useManageImagesStore'

type TextProps = React.ComponentProps<typeof Text>
const textProps: Pick<TextProps, 'fontSize' | 'letterSpacing' | 'lineHeight'> =
  {
    fontSize: 'medium',
    letterSpacing: 'wider',
    lineHeight: '20',
  }

type StyleInfoProps = {
  style?: Style | null
}

const StyleInfo = ({ style }: StyleInfoProps): JSX.Element => {
  const isStyleDataLoading = useManageImagesStore(
    (state) => state.isStyleDataLoading,
  )
  const id = fromGlobalId(style?.styleId).id
  return (
    <div>
      {isStyleDataLoading ? (
        <>
          <LoadingSkeleton />
          <LoadingSkeleton />
          <LoadingSkeleton />
          <LoadingSkeleton />
        </>
      ) : (
        <>
          <Text {...textProps} data-testid={StyleInfoIds.StyleId}>{`${
            id ? `${id} - ` : ''
          }${style?.styleNumber}`}</Text>
          <Text
            {...textProps}
            data-testid={StyleInfoIds.StyleName}
            fontWeight="bold"
          >
            {style?.styleName}
          </Text>
          {(style?.fabrication?.name || style?.fabrication?.code) && (
            <Text {...textProps} data-testid={StyleInfoIds.StyleFabrication}>
              {formatNameWithCodeAndDash(
                style.fabrication.name,
                style.fabrication.code,
              )}
            </Text>
          )}
          {(style?.silhouette?.name || style?.silhouette?.code) && (
            <Text {...textProps} data-testid={StyleInfoIds.StyleSilhouette}>
              {formatNameWithCodeAndDash(
                style.silhouette.name,
                style.silhouette.code,
              )}
            </Text>
          )}
        </>
      )}
    </div>
  )
}

export default StyleInfo
